import React from 'react';

function Vettriage() {
    return (
        <div>
            <section id="about-index">
                <div class="container">
                    <div class="section-heading text-center"><br />
                    </div>
                    <div class="row">
                        <div class="col-md-6 text-center">
                            <img src="/assets/img/veterinarian.jpg" width="70%" alt="" />
                        </div>
                        <div class="col-md-6">
                            <br /><br /><br /><br />
                            <a href='#' className='btn'>Connect to Veterinarian</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Vettriage;